import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import Slider from "react-slider";
import { RingLoader } from "react-spinners";
import AVReactPlayer from "./AVReactPlayer";
import { useMediaQuery } from "react-responsive";
import Switch from "react-switch";
import AudioWaveform from "./AudioWaveform";
import ReactPlayer from "react-player";

const StyledThumb = styled.div`
    height: 60px;
    width: 9px;
    background: linear-gradient(to right, #bbb, #777);
    cursor: grab;
    border-radius: 25px;
    border: 2px solid #ccc;
`;

const Thumb = (props, state) => <StyledThumb {...props} />;

const StyledTrack = styled.div`
    top: 10px;
    bottom: 0;
    border-radius: 10px;
    background: ${(props) =>
        !props.switchValue1
            ? props.index === 2
                ? "#ddd"
                : props.index === 1
                ? "#0fa"
                : "#ddd"
            : props.index === 2
            ? "#0fa"
            : props.index === 1
            ? "#ddd"
            : "#0fa"};
`;

const Track = ({ index, switchValue1, ...props }) => (
    <StyledTrack {...props} index={index} switchValue1={switchValue1} />
);

const Container = styled.div`
    /* Стили для контейнера */
`;

const StyledSlider = styled(Slider)`
    width: 100%;
    height: 50px;
    margin-top: 50px; /* Добавлено для отступа между тултипами и слайдером */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    } /* Добавлено закрывающее свойство для &:hover */
    color: white; /* Добавлен цвет текста для единообразия с StyledButton */
    font-size: 1.5em; /* Добавлен размер шрифта для единообразия с StyledButton */
    padding: 10px 20px; /* Добавлены отступы для единообразия с StyledButton */
    border-radius: 5px; /* Добавлен радиус границ для единообразия с StyledButton */
    font-weight: bold; /* Добавлен жирный шрифт для единообразия с StyledButton */
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const TooltipContainer = styled.div`
    position: absolute;
    top: -50px; /* Перемещено выше слайдера */
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 15px;
`;

const Tooltip = styled.div`
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 0.9em;
`;

const HiddenDiv = styled.div`
    display: ${({ show }) => (show ? "block" : "none")};
    margin-top: 20px;
`;

const ToggleButton = styled.button`
    width: 100%;
    background-color: #e0e0e0;
    color: #333;
    padding: 10px;
    border: none;
    text-align: center;
    font-size: 1em;
    cursor: pointer;
    border-radius: 5px;
`;

const convertToTime = (value) => {
    const hours = Math.floor(value / (60 * 60 * 1000));
    const minutes = Math.floor((value - hours * 60 * 60 * 1000) / (60 * 1000));
    const seconds = Math.floor(
        (value - hours * 60 * 60 * 1000 - minutes * 60 * 1000) / 1000
    );
    const milliseconds = value % 1000;
    return [hours, minutes, seconds, milliseconds];
};

const formatTime = ([hours, minutes, seconds, milliseconds]) => {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
    )}:${String(seconds).padStart(2, "0")}.${String(milliseconds).padStart(
        3,
        "0"
    )}`;
};

const AVTrimSlider = (props) => {
    const {
        titleDownload,
        titleDelete,
        titleTrimAnotherAudio,
        titleTrim,
        titleHours,
        titleMinutes,
        titleSeconds,
        titleMilliseconds,
        titleStart,
        titleEnd,
        titleReady,
        titleCurrentFile,
        tip1,
        tip2,
        titleFadeIn,
        titleFadeOut,
        titleRemoveVocal,
        titleAdditionalOptions,
    } = props.attributes;

    const [sliderValue, setSliderValue] = useState([0, props.duration]);
    const [startValue, setStartValue] = useState(convertToTime(0));
    const [endValue, setEndValue] = useState(convertToTime(props.duration));
    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [switchValue1, setSwitchValue1] = useState(false);
    const [switchValue2, setSwitchValue2] = useState(false);
    const [showPlayer, setShowPlayer] = useState(true);
    /* const [waveform, setWaveform] = useState(null); */
    const [fadeIn, setFadeIn] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    const [removeVocals, setRemoveVocals] = useState(false);
    const [showOptions, setShowOptions] = useState(false);

    useEffect(() => {
        setSliderValue([0, props.duration]);
        setStartValue(convertToTime(0));
        setEndValue(convertToTime(props.duration));
    }, [props.duration]);

    useEffect(() => {
        setStartValue(convertToTime(sliderValue[0]));
        setEndValue(convertToTime(sliderValue[1]));
    }, [sliderValue]);

    const handleTrim = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowPlayer(false);
        const requestBody = {
            starttime: sliderValue[0],
            endtime: sliderValue[1],
            fileid: props.fileId,
            switchValue1: switchValue1,
            switchValue2: switchValue2,
            fadeIn: fadeIn,
            fadeOut: fadeOut,
            removeVocals: removeVocals,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/trimAudio?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleChangeSlider = (newValue) => {
        setSliderValue(newValue);
    };

    const handleChangeSwitch1 = () => {
        setSwitchValue1(!switchValue1);
        setSwitchValue2(false);
    };

    const handleChangeSwitch2 = () => {
        setSwitchValue2(!switchValue2);
    };

    const handleInputChange = (index, event) => {
        const timeValue = event.target.value;
        const [hours, minutes, seconds, milliseconds] =
            index === 0 ? startValue : endValue;
        const newSliderValue = [hours, minutes, seconds, milliseconds];
        newSliderValue[event.target.name] = parseInt(timeValue);

        const newTime =
            newSliderValue[0] * 60 * 60 * 1000 +
            newSliderValue[1] * 60 * 1000 +
            newSliderValue[2] * 1000 +
            newSliderValue[3];

        if (newTime > props.duration || newTime < 0) {
            return;
        }

        if (index === 0 && newTime <= sliderValue[1]) {
            setSliderValue([newTime, sliderValue[1]]);
        } else if (index === 1 && newTime >= sliderValue[0]) {
            setSliderValue([sliderValue[0], newTime]);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowPlayer(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const isMobileDevice = useMediaQuery({
        query: "(max-width: 768px)",
    });

    const reloadPage = () => {
        setShowPlayer(true);
        location.reload();
    };

    const handleCurrentTimeChange = (time) => {
        console.log(time);
    };

    const [currentTime, setCurrentTime] = useState(0);

    const handleWaveformSeek = useCallback((newTime) => {
        setCurrentTime(newTime);
    }, []);

    const handleProgress = useCallback((playedSeconds) => {
        setCurrentTime(playedSeconds);
    }, []);

    const [clickedTime, setClickedTime] = useState(null);

    const handleTimeClick = (time) => {
        setClickedTime(time);
    };

    const handleRegionChange = (start, end) => {
        setSliderValue([start * 1000, end * 1000]);
    };

    const handleFadeInChange = () => {
        setFadeIn(!fadeIn);
    };

    const handleFadeOutChange = () => {
        setFadeOut(!fadeOut);
    };

    return (
        <Container>
            {showPlayer && (
                <>
                    <div>
                        {titleCurrentFile}: {props.fileName}
                    </div>

                    <div className="px-4 py-2">
                        {props.audioUrl && (
                            <AudioWaveform
                                audioFile={props.audioUrl}
                                /*  waveform={waveform} */
                                regionStart={sliderValue[0] / 1000}
                                regionEnd={sliderValue[1] / 1000}
                                currentTime={currentTime}
                                onTimeClick={handleTimeClick}
                                onRegionChange={handleRegionChange}
                            />
                        )}
                        {props.audioUrl && (
                            <AVReactPlayer
                                url={props.audioUrl}
                                startTime={clickedTime}
                                onProgress={handleProgress}
                            />
                        )}

                        <div style={{ position: "relative" }}>
                            <TooltipContainer>
                                <Tooltip>{formatTime(startValue)}</Tooltip>
                                <Tooltip>{formatTime(endValue)}</Tooltip>
                            </TooltipContainer>
                            <StyledSlider
                                value={sliderValue}
                                onChange={handleChangeSlider}
                                min={0}
                                max={props.duration}
                                step={1}
                                pearling
                                minDistance={1}
                                renderTrack={(props, state) => (
                                    <Track
                                        {...props}
                                        index={state.index}
                                        switchValue1={switchValue1}
                                    />
                                )}
                                renderThumb={Thumb}
                            />
                        </div>
                    </div>
                    {!switchValue2 && (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "1em",
                                }}
                            >
                                <Switch
                                    onChange={handleChangeSwitch1}
                                    checked={switchValue1}
                                />
                                <span
                                    style={{
                                        marginLeft: "10px",
                                        padding: "10px",
                                        backgroundColor: "lightblue",
                                        color: "darkblue",
                                        fontSize: "0.7em",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {tip1}
                                </span>
                            </div>
                        </>
                    )}

                    <div className="overflow-x-auto w-full">
                        <table className="table-auto w-full">
                            <thead>
                                <tr>
                                    {!isMobileDevice && (
                                        <th className="px-4 py-2 w-1/5"></th>
                                    )}
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleHours}
                                    </th>
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleMinutes}
                                    </th>
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleSeconds}
                                    </th>
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleMilliseconds}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {!isMobileDevice && (
                                        <td className="px-4 py-2">
                                            {titleStart}:
                                        </td>
                                    )}
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={0}
                                            value={startValue[0]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={1}
                                            value={startValue[1]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={2}
                                            value={startValue[2]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={3}
                                            value={startValue[3]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    {!isMobileDevice && (
                                        <td className="px-4 py-2">
                                            {titleEnd}:
                                        </td>
                                    )}
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={0}
                                            value={endValue[0]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={1}
                                            value={endValue[1]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={2}
                                            value={endValue[2]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={3}
                                            value={endValue[3]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "1em",
                        }}
                    >
                        <span
                            style={{
                                marginLeft: "10px",
                                padding: "10px",
                                backgroundColor: "lightblue",
                                color: "darkblue",
                                fontSize: "0.7em",
                                borderRadius: "4px",
                            }}
                        >
                            {tip2}
                        </span>
                        <div
                            style={{
                                marginLeft: "10px",
                                display: "flex",
                                alignItems: "center",
                                marginRight: "1em",
                            }}
                        >
                            <Switch
                                onChange={handleFadeInChange}
                                checked={fadeIn}
                            />
                            <span
                                style={{
                                    marginLeft: "10px",
                                    padding: "10px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                }}
                            >
                                {titleFadeIn}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Switch
                                onChange={handleFadeOutChange}
                                checked={fadeOut}
                            />
                            <span
                                style={{
                                    marginLeft: "10px",
                                    padding: "10px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                }}
                            >
                                {titleFadeOut}
                            </span>
                        </div>
                    </div>

                    <ToggleButton onClick={() => setShowOptions(!showOptions)}>
                        {titleAdditionalOptions}
                    </ToggleButton>
                    <HiddenDiv show={showOptions}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Switch
                                id="removeVocals"
                                checked={removeVocals}
                                onChange={(checked) => setRemoveVocals(checked)}
                            />
                            <span
                                style={{
                                    marginLeft: "10px",
                                    padding: "10px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                }}
                            >
                                {titleRemoveVocal}:
                            </span>
                        </div>
                    </HiddenDiv>

                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={handleTrim}>
                                {titleTrim}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleTrimAnotherAudio}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    <div className="px-4 py-2">
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <ReactPlayer
                                url={downloadUrl}
                                controls
                                width="90%"
                                height="100px"
                            />
                        </div>
                    </div>
                    <ButtonContainer>
                        <a
                            href={downloadUrl}
                            download={getFileName(downloadUrl)}
                            onClick={handleDownload}
                        >
                            <StyledButton>{titleDownload}</StyledButton>
                        </a>
                        <a className="pl-2" onClick={handleDownload}>
                            <StyledButtonDelete>
                                {titleDelete}
                            </StyledButtonDelete>
                        </a>
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleTrimAnotherAudio}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default AVTrimSlider;
